import appleBusinessChat from "./business-chat-logo.svg";
import blipChat from "./blipchat-logo.svg";
import email from "./mailgun-logo.svg";
import googleAssistant from "./google-assistant-logo.svg";
import googleRcs from "./google-rcs-logo.svg";
import infoBip from "./infobip-logo.svg";
import messenger from "./messenger-logo.svg";
import skype from "./skype-logo.svg";
import telegram from "./telegram-logo.svg";
import whatsApp from "./whatsapp.svg";
import workplace from "./workplace-logo.svg";
import cancel from './cancel.svg';
import check from './check.svg';
import microsoftTeams from './microsoft-teams.svg';
import instagram from './instagram.svg';
import googleBusiness from './googleBusiness.svg';
import alexa from './alexa.svg';

import image from "./image.svg";
import menu from "./menu.svg";
import quickReply from "./quickReply.svg";

export const channelSvgs = {
    appleBusinessChat,
    blipChat,
    email,
    googleAssistant,
    googleRcs,
    infoBip,
    messenger,
    skype,
    telegram,
    whatsApp,
    workplace,
    microsoftTeams,
    instagram,
    googleBusiness,
    alexa,
    
};

export const contentTypeSvgs = {
    image,
    menu,
    quickReply,
    cancel,
    check
}